module.exports.spriggy = require('./spriggy/index');
module.exports.nab = require('./nab/index');
module.exports.kogan = require('./kogan/index');
module.exports.jbwere = require('./jbwere/index');